import { gql } from '@apollo/client';
import { FieldFragment } from 'graphql/Field/fragments/FieldFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
import { SaleItemFileFragment } from 'graphql/SaleItemFile/fragments/SaleItemFileFragment';
import { SaleItemGroupFragment } from 'graphql/SaleItemGroup/fragments/SaleItemGroupFragment';
import { SaleItemImageFragment } from 'graphql/SaleItemImage/fragments/SaleItemImageFragment';
import { TaxFragment } from 'graphql/Tax/fragments/TaxFragment';
/**
 * @fragment SaleItemFragment
 * @since 1.0.0
 */
export const SaleItemFragment = gql `
  fragment SaleItemFragment on SaleItem {
    id
    sku
    price
    cost
    inventory
    category
    configuration
    optionConfiguration
    active
    promoted
    order
    showInCalendar
    exclusiveTimeSlot
    visibility
    unitOfMeasurement
    quantityCalculation
    voucherEligible
    voucherValidityType
    voucherValidityDays
    voucherValidityDate
    requiresPlannedDate
    trackQuantity
    trackInventory
    outOfStockPolicy
    taxable
    title
    summary
    infos
    createdAt
    updatedAt

    taxes {
      ...TaxFragment
    }

    partners {
      id
      name
    }

    relations {
      id
      type
      quantity
      saleItemId
      relatedSaleItemId
      saleItem {
        id
        title
        price
        sku
      }
      relatedSaleItem {
        id
        title
        price
        sku
      }
      createdAt
      updatedAt
    }

    group {
      ...SaleItemGroupFragment
    }

    groups {
      ...SaleItemGroupFragment
    }

    image {
      ...SaleItemImageFragment
    }

    images {
      ...SaleItemImageFragment
    }

    files {
      ...SaleItemFileFragment
    }

    translations {
      id
      title
      summary
      infos
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }

    variants {
      id
      sku
      price
      inventory
      createdAt
      updatedAt
      active

      image {
        ...MediaFragment
      }

      options {
        id
        price
        item {
          id
          sku
          title
          infos
          price
          relations {
            id
            type
            quantity
            relatedSaleItem {
              id
              title
              price
              sku
            }
          }
          group {
            id
            title
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }

          image {
            ...SaleItemImageFragment
          }
        }
        included
        locked
        proposed
        recommended
      }

      values {
        id
        value
        field {
          ...FieldFragment
        }
      }

      fieldValues {
        id
        value
        field {
          ...FieldFragment
        }
      }
    }

    options {
      id
      price
      feeValue
      quantity
      required
      included
      locked
      proposed
      recommended
      quantityEditable
      order
      relations {
        id
        type
        quantity
        saleItem {
          id
          title
          infos
          sku
          price
          taxable
          category
          configuration
          optionConfiguration
          group {
            id
            title
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          active
          promoted
          createdAt
          updatedAt
        }
        relatedSaleItem {
          id
          title
          infos
          sku
          price
          taxable
          category
          configuration
          optionConfiguration
          group {
            id
            title
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          active
          promoted
          createdAt
          updatedAt
        }
      }
      item {
        id
        title
        infos
        sku
        price
        taxable
        inventory
        category
        configuration
        optionConfiguration
        group {
          id
          title
          display
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }
        active
        promoted
        relations {
          id
          type
          quantity
          relatedSaleItem {
            id
            title
            price
            sku
          }
        }

        image {
          ...SaleItemImageFragment
        }
      }
    }

    fieldValues {
      value
      field {
        id
        name
        title
        infos
        visibility
        promote
        type
        options
        group {
          id
          category
        }
      }
    }

    packages {
      id
      included
      locked
      proposed
      package {
        id
        title
        infos
        price
        active
      }
    }

    manufacturing {
      id
      item {
        id
        sku
        title
      }
      quantity
    }

    associatedProducts {
      id
      sku
      title
    }
  }

  ${SaleItemGroupFragment}
  ${LanguageFragment}
  ${SaleItemImageFragment}
  ${SaleItemFileFragment}
  ${FieldFragment}
  ${MediaFragment}
  ${TaxFragment}
`;
